// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StripeElement{width:100%;height:47px;font:300 18px \"DINNextLTPro\", Helvetica, Arial, sans-serif;font-weight:700;padding:0.7em 1em;background-color:#F9F9FA;border:solid 1px #C0C5C9;border-radius:2px;transition-property:border-color;transition-duration:0.2s;transition-timing-function:ease;transition-delay:0s;line-height:1em}.checkout-form .col-8,.checkout-form .col-12{padding:0}.checkout-form .col-4{padding:0 0 0 10px}\n", ""]);
// Exports
module.exports = exports;
